import { confetti } from './moddedTsPresets/confetti';
// import { CONFETTI_THEMES } from '../../model/particleModels';
// import { PARTICLES_CONTROLLER } from '../ParticlesController';
// import main from '../../main';
// import koko from '../../koko-framework/koko';
// import app from '../../koko-framework/app';

// import our confetti assets from ./assets/ we have confetti1.png to confetti6.png
import confetti1 from './assets/confetti1.png';
import confetti2 from './assets/confetti2.png';
import confetti3 from './assets/confetti3.png';
import confetti4 from './assets/confetti4.png';
import confetti5 from './assets/confetti5.png';
import confetti6 from './assets/confetti6.png';
const confettiAssets = [confetti1, confetti2, confetti3, confetti4, confetti5, confetti6];

/**
 * @author Carl Trelfa
 */

class ConfettiEffectController {
    inited = false;
    running = false;

    customisationData = null;
    onEnded = null;

    imageList = [];
    processedAssets = [];

    // confettiPopSoundIds = [];

    burstTimeoutId = null;
    activeParticles = 0; // Counter for active particles

    init(customisationData, onEnded = () => {console.log('Confetti onEnded called')}) {
        if (!this.inited) {
            this.customisationData = customisationData;
            this.onEnded = onEnded;
            this.inited = true;
            this.prepareConfettiAssets();
            this.preProcessAssets();
        }
    }

    prepareConfettiAssets() {
        // Preload all confetti assets and push onto imageList
        for (let i = 0; i < confettiAssets.length; i++) {
            const imageUrl = confettiAssets[i];
            this.imageList.push({src: imageUrl, enableRecolouring: true});
        }
    }

    /* prepareAssetsForLoading() {
        if (this.inited && this.customisationData) {
            if (this.customisationData.particleOptions.confettiSettings.style[0].selectedTheme !== 'custom') {
                const themeData = CONFETTI_THEMES[this.customisationData.particleOptions.confettiSettings.style[0].selectedTheme];
                for (let i = 0; i < themeData.variations; i++) {
                    const imageUrl = './img/confetti-themes/' + themeData.prefix + (i + 1) + '.png';
                    this.imageList.push({src: imageUrl, enableRecolouring: true});
                    PARTICLES_CONTROLLER.queueUpHtmlAssetForPreload('confetti' + i, imageUrl);
                }
            } else {
                // console.log('--- ConfettiEffectController: prepareAssetsForLoading ---', this.customisationData);
                const customImages = this.customisationData.particleOptions.confettiSettings.customImages;
                // console.log('Custom images: ', customImages);
                for (let i = 0; i < customImages.length; i++) {
                    const imageUrl = customImages[i].image.srcUrl;
                    const imgObj = {src: imageUrl, enableRecolouring: customImages[i].enableRecolouring};
                    for (let j = 0; j < Math.ceil(customImages[i].frequency / 10); j++) {
                        this.imageList.push(imgObj);
                    }
                    PARTICLES_CONTROLLER.queueUpHtmlAssetForPreload('confetti' + i, imageUrl);
                }
                // console.log('Image list: ', this.imageList);
            }

            // Add confetti pop sounds for preloading
            if (!Array.isArray(main.additionalSounds)) {
                main.additionalSounds = [];
            }
            if (this.customisationData.particleOptions.confettiSettings.style[0].appearStyle !== 'fromTop') {
                // no audio when falling from the top
                if (this.customisationData.audio.audio.toggleSFX[0].confettiPop === true) {
                    const confettiPopSounds = this.customisationData.audio.audio.confettiPops;
                    for (let i = 0; i < confettiPopSounds.length; i++) {
                        if (confettiPopSounds[i].filename.srcUrl) {
                            const soundId = 'confettiPop' + i;
                            this.confettiPopSoundIds.push(soundId);
                            main.additionalSounds.push({ id: soundId, srcUrl: confettiPopSounds[i].filename.srcUrl, volume: Number(confettiPopSounds[i].volume) });
                        }
                    }
                }
            }
        }
    } */

    // We are going to preprocess our assets here so we can recolour them because using the particle libraries recolor option proved unreliable.
    preProcessAssets() {
        // const confettiCustomisations = this.customisationData.particleOptions.confettiSettings.style[0];
        const colours = this.customisationData; // .particleOptions.confettiSettings.colours;

        // Our processed assets look like this in the array:
        // {src: 'imageUrl', scale: 1, enableRecolouring: true}

        // if (confettiCustomisations.selectedTheme !== 'custom' || confettiCustomisations.enableRecolouring) {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = 100;
            canvas.height = 100;

            for (let img = 0; img < this.imageList.length; img++) {
                let image = new Image();
                image.src = this.imageList[img].src;
                image.crossOrigin = "anonymous"; // Enable CORS for this image
                image.onload = () => {
                    // const enableRecolouring = true; // this.imageList[img].enableRecolouring;

                    // Set the canvas size to match the original image dimensions
                    canvas.width = image.width;
                    canvas.height = image.height;

                    // console.log('Image loaded: ', image.src, enableRecolouring, image.width, image.height);

                    for (let i = 0; i < colours.length; i++) {
                        // Clear the canvas
                        ctx.clearRect(0, 0, canvas.width, canvas.height);

                        // Draw the original image on the canvas
                        ctx.globalCompositeOperation = 'source-over';
                        ctx.drawImage(image, 0, 0);

                        // Apply recoloring if enabled
                        // if (enableRecolouring) {
                            ctx.globalCompositeOperation = 'source-in';
                            ctx.fillStyle = colours[i].colour;
                            ctx.fillRect(0, 0, canvas.width, canvas.height);
                            ctx.globalCompositeOperation = 'destination-over';
                            ctx.drawImage(image, 0, 0);
                            ctx.globalCompositeOperation = 'source-over';
                        // }

                        // Convert the canvas to a data URL
                        const imageUrl = canvas.toDataURL('image/png');
                        const assetObj = { src: imageUrl };

                        // Push the processed asset multiple times based on frequency
                        for (let j = 0; j < Math.ceil(colours[i].frequency / 10); j++) {
                            this.processedAssets.push(assetObj);
                        }
                    }

                    // Free up memory from this image
                    /* image.onload = null;
                    image.src = null;
                    image = null; */
                };
            }
        /* } else {
            // Just copy the image list to the processed assets
            for (let i = 0; i < this.imageList.length; i++) {
                this.processedAssets.push(this.imageList[i]);
            }
        } */
        // console.log('Processed assets: ', this.processedAssets);
    }

    start() {
        this.running = true;
        this.createConfettiBurst(0, true);
    }

    end() {
        this.running = false;
        clearTimeout(this.burstTimeoutId);
        if (!this.hasLiveParticles() && this.onEnded) {
            // console.log('Confetti ended');
            this.onEnded();
        }
    }

    createConfettiBurst(number = 1, initialBurst = false) {
        if (this.running) {
            // const confettiCustomisations = this.customisationData.particleOptions.confettiSettings.style[0];
            const speed = 26;
            const particleCount = 50;
            const particleScale = 74;

            const shapeOptions = { image: this.processedAssets };
            const burstSize = /* confettiCustomisations.appearStyle === 'fromTop' ? */ 15 + speed / 20 /* : 10 + confettiCustomisations.burstSize / 100 * 50 */;
            const burstFrequencyDelayMult = /* confettiCustomisations.appearStyle === 'fromTop' ? */ 0.5 /* : (105 - confettiCustomisations.burstFrequency) / 100 * 1.5 */;

            const canvas = document.querySelector('canvas');
            const confettiOptions = {
                ticks: 50,
                gravity: 0.5 + speed / 20,
                decay: 0.94,
                scalar: (particleScale / 100 * 3), // * app.scale,
                spread: 360,
                angle: 0,
                startVelocity: burstSize,
                particleCount: Math.ceil(particleCount / (/* confettiCustomisations.appearStyle === 'fromTop' ? 10 : 5 */ 10)),
                origin: { x: 0.5, y: 0.5 },
                shapes: ['image'],
                shapeOptions: shapeOptions,
                canvas: canvas,
            };

            // if (confettiCustomisations.rotation === 'none') {
            //     confettiOptions.noRotate = true;
            // }
            // if (confettiCustomisations.rotation === 'flat' /* || confettiCustomisations.rotation === 'none' */) {
            //     confettiOptions.flat = true;
            // }

            for (let i = 0; i < number; i++) {
                let originY = 0.5;
                let originX = 0.5;

                originY = -0.05 - Math.random() * 0.1;
                originX = Math.random();
                confettiOptions.angle = 90;
                confettiOptions.spread = 180;

                // switch (confettiCustomisations.appearStyle) {
                //     case 'fromTop':
                //         originY = -0.05 - Math.random() * 0.1;
                //         originX = Math.random();
                //         confettiOptions.angle = 90;
                //         confettiOptions.spread = 180;
                //         break;
                //     case 'allOver':
                //         originY = Math.random();
                //         originX = Math.random();
                //         break;
                //     case 'burstFromSides':
                //         originY = Math.random();
                //         originX = Math.random() < 0.5 ? -(Math.random() * 0.1) : 1 + Math.random() * 0.1;
                //         confettiOptions.angle = originX < 0.5 ? 0 : 180;
                //         confettiOptions.spread = 180;
                //         break;
                //     case 'burstFromBottom':
                //         originY = 1 + Math.random() * 0.1;
                //         originX = Math.random();
                //         confettiOptions.angle = 90;
                //         confettiOptions.spread = 180;
                //         break;
                //     default:
                //         break;
                // }
                confettiOptions.origin = { x: originX, y: originY };

                // Increment active particles counter
                this.activeParticles += confettiOptions.particleCount;

                // Create confetti
                // console.log('Creating confetti: ', confettiOptions);
                confetti(confettiOptions);
                // this.playConfettiPopSound();

                // Decrement active particles after the confetti's lifetime
                // This lifetime is just an approximation, it's pretty difficult to get it right for all cases, so I'm going to say, this'll do
                let lifeTime = /* confettiCustomisations.appearStyle === 'fromTop' ? */ confettiOptions.ticks * (110 * (1.1 - originY) - speed * 2) /* : confettiOptions.ticks * (30 * confettiCustomisations.burstSize / 100) */;
                if (lifeTime < 700) {
                    lifeTime = 700;
                }
                setTimeout(() => {
                    this.activeParticles -= confettiOptions.particleCount;
                    // console.log('Active particles: ', this.activeParticles);
                    if (this.activeParticles <= 0) {
                        this.activeParticles = 0; // Prevent negative values
                        // console.log('No active particles left...', this.running, this.onEnded);
                        if (!this.running && this.onEnded) {
                            // console.log('Confetti ended');
                            this.onEnded();
                        }
                    }
                }, lifeTime); // Approximate ticks duration in milliseconds
            }

            this.burstTimeoutId = setTimeout(() => {
                this.createConfettiBurst();
            }, !initialBurst ? (60 * burstFrequencyDelayMult) + Math.random() * 500 * burstFrequencyDelayMult : 50);
        }
    }

    /* playConfettiPopSound() {
        if (this.customisationData.particleOptions.confettiSettings.style[0].appearStyle !== 'fromTop') {
            // no audio when falling from the top
            if (this.customisationData.audio.audio.toggleSFX[0].confettiPop === true && this.confettiPopSoundIds.length > 0) {
                const soundId = this.confettiPopSoundIds[Math.floor(Math.random() * this.confettiPopSoundIds.length)];
                // console.log('Playing sound: ', soundId);
                koko.audio.play(soundId, 1, false, 0, true);
            }
        }
    } */

    // Method to check if there are live particles
    hasLiveParticles() {
        return this.activeParticles > 0;
    }
}

export const CONFETTI_EFFECT_CONTROLLER = new ConfettiEffectController();